import AreaParser from './main';
import MiniAreaParser from './mini';

export default {
  main: AreaParser,
  mini: MiniAreaParser,
};
